import styled, { css } from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { color, fontSize, spacing, radius, variant, themeMode } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Heading } from '../Heading/Heading.es.js';
import { AlertAction } from './AlertAction.es.js';
styled(Box).withConfig({
  componentId: "sc-1yp6peh-0"
})(["display:flex;flex-direction:column;"]);
var iconVariantStyles = variant({
  prop: "palette",
  variants: {
    default: {
      color: "neutral.500"
    },
    success: {
      color: "primary.500"
    },
    danger: {
      color: "danger.500"
    },
    warning: {
      color: "warning.500"
    },
    info: {
      color: "secondary.500"
    }
  }
});
var Icon = styled(Box).withConfig({
  componentId: "sc-1yp6peh-1"
})(["display:inline-flex;grid-area:icon;grid-row:1 / -1;", ";"], iconVariantStyles);
var Title = styled(Heading).withConfig({
  componentId: "sc-1yp6peh-2"
})(["margin-bottom:0;grid-column:2;"]);
Title.displayName = "Alert.Title";
var Content = styled(Box).withConfig({
  componentId: "sc-1yp6peh-3"
})(["grid-column:2;color:", ";font-size:", ";"], color("text.base"), fontSize("base"));
Content.displayName = "Alert.Content";
var ActionGroup = styled(Box).withConfig({
  componentId: "sc-1yp6peh-4"
})(["grid-column:2;"]);
var Action = styled(AlertAction).withConfig({
  componentId: "sc-1yp6peh-5"
})(["grid-column:2;"]);
Action.displayName = "Alert.Action";
var messageVariants = variant({
  prop: "palette",
  compoundProp: "variant",
  variants: {
    default: {
      solid: {
        backgroundColor: themeMode({
          light: "neutral.100",
          dark: "neutral.800"
        })
      },
      outline: {
        borderColor: themeMode({
          light: "neutral.200",
          dark: "neutral.800"
        })
      },
      subtle: {
        backgroundColor: themeMode({
          light: "neutral.50",
          dark: color("neutral.800", 0.16)
        })
      },
      ghost: {}
    },
    success: {
      solid: {
        backgroundColor: themeMode({
          light: "neutral.100",
          dark: "neutral.800"
        })
      },
      outline: {
        borderColor: themeMode({
          light: "neutral.200",
          dark: "neutral.800"
        })
      },
      subtle: {
        backgroundColor: color("success.500", 0.08)
      },
      ghost: {}
    },
    warning: {
      solid: {
        backgroundColor: themeMode({
          light: "neutral.100",
          dark: "neutral.800"
        })
      },
      outline: {
        borderColor: themeMode({
          light: "neutral.200",
          dark: "neutral.800"
        })
      },
      subtle: {
        backgroundColor: color("warning.500", 0.08)
      },
      ghost: {}
    },
    danger: {
      solid: {
        backgroundColor: themeMode({
          light: "neutral.100",
          dark: "neutral.800"
        })
      },
      outline: {
        borderColor: themeMode({
          light: "neutral.200",
          dark: "neutral.800"
        })
      },
      subtle: {
        backgroundColor: color("danger.500", 0.08)
      },
      ghost: {}
    },
    info: {
      solid: {
        backgroundColor: themeMode({
          light: "neutral.100",
          dark: "neutral.800"
        })
      },
      outline: {
        borderColor: themeMode({
          light: "neutral.200",
          dark: "neutral.800"
        })
      },
      subtle: {
        backgroundColor: color("secondary.500", 0.08)
      },
      ghost: {}
    }
  }
});
var Alert = styled(Box).withConfig({
  componentId: "sc-1yp6peh-6"
})(["display:grid;grid-template-columns:min-content 1fr;grid-auto-rows:min-content;gap:", ";grid-template-areas:'icon .';padding:", ";border-radius:", ";border:1px solid transparent;", " ", ";"], spacing("xs"), spacing("lg"), radius("base"), function (_ref) {
  var isInline = _ref.isInline;
  return isInline && css(["display:flex;", "{margin-left:auto;}"], ActionGroup);
}, messageVariants);
export { Action, ActionGroup, Alert, Content, Icon, Title };